/** Stormcloud player script used by the album video pages (and pre-loaded by the new video detail page). */
export const STORMCLOUD_SCRIPT_URL = 'https://cdn.jsdelivr.net/npm/stormcloud-video-player@0.3.63/dist/stormcloud-vp.min.js';
